"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxOptionMedia = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * @since 8.28.0
 */
var ListboxOptionMedia = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "ListboxOptionMedia",
  componentId: "c11n-8-101-0__sc-h1w6cf-0"
})([""]);
exports.ListboxOptionMedia = ListboxOptionMedia;
ListboxOptionMedia.displayName = 'ListboxOptionMedia';

/** @component */